import type { JSX } from 'react';

import { Box, Container } from '@change-corgi/design-system/layout';

import { PageBanner } from '../components/PageBanner';
import { PageBody } from '../components/PageBody';
import { PageFooter } from '../components/PageFooter';
import { PageHeading } from '../components/PageHeading';
import { PageMeta } from '../components/PageMeta';
import { PageState } from '../components/PageState';

import { usePullBandits } from './hooks/usePullBandits';
import { useTrackPageView } from './hooks/useTrackPageView';

export function Layout(): JSX.Element {
	useTrackPageView();
	usePullBandits();

	return (
		<>
			<PageBanner />
			<Box
				sx={{
					// TODO switch to a new DS color (check with Design team)
					backgroundColor: '#FFFCF7',
					minHeight: '100vh',
					width: '100%',
				}}
				pt={24}
				pb={40}
			>
				<Container variant="small" px={[8, 0]} sx={{ maxWidth: 885 }}>
					<PageMeta />
					<PageState />
					<PageHeading />
					<PageBody />
					<PageFooter />
				</Container>
			</Box>
		</>
	);
}
